import { Injectable } from '@angular/core'
import {
  PluginInjectorService,
	PluginInjectorApplicationPlugin,
	IWidgetPermissions
} from 'core-client/api'
import { MapWidgetAddComponent } from './map/map-widget-add/map-widget-add.component'
import { MapWidgetViewComponent } from './map/map-widget-view/map-widget-view.component'
import { MapWidgetSettingsComponent } from './map/map-widget-settings/map-widget-settings.component'

@Injectable({
  providedIn: 'root'
})
export class MapService {
  private readonly plugin: PluginInjectorApplicationPlugin.IApplicationPlugin = <PluginInjectorApplicationPlugin.IApplicationPlugin>{};

  private widgetPermissions: IWidgetPermissions = {
    map_widget_add_enabled: false,
    map_widget_header_display: false,
    map_widget_settings_edit: false,
    map_widget_wms_chart_loader_enabled: false,
    map_widget_ngsild_connector_enabled: false,
    map_widget_ais_targets_data_enabled: false,
    map_widget_ais_prediction_data_enabled: false,
    map_widget_maritime_targets_data_enabled: false,
    map_widget_planned_path_data_enabled: false,
    map_widget_radar_target_data_enabled: false,
    map_widget_fusion_maritime_target_data_enabled: false
  };

  private readonly pluginModule: PluginInjectorApplicationPlugin.IPluginModule = {
    widgets: [{
      pluginModule: 'MAP',
      pluginId: '',
      widgetPermissions: {
        widgetEnabledPermission: {
          permissionRef: 'map_widget_add_enabled'
        },
        widgetBasePermissions: {
          widgetSettingsEnabledPermission: {
            permissionRef: 'map_widget_settings_edit'
          },
          autorizeDisplayOfWidgetHeader: {
            permissionRef: 'map_widget_header_display'
          }
        },
        widgetAdditionalPermissions: {
          authorizeWmsChartLoader: {
            permissionRef: 'map_widget_wms_chart_loader_enabled'
          },
          authorizeNgsildConnector: {
            permissionRef: 'map_widget_ngsild_connector_enabled'
          },
          enableAisTargetsData: {
            permissionRef: 'map_widget_ais_targets_data_enabled'
          },
          enableAisPredictionData: {
            permissionRef: 'map_widget_ais_prediction_data_enabled'
          },
          enableMaritimeTargetsData: {
            permissionRef: 'map_widget_maritime_targets_data_enabled'
          },
          enablePlannedPathData: {
            permissionRef: 'map_widget_planned_path_data_enabled'
          },
          enableRadarTargetData: {
            permissionRef: 'map_widget_radar_target_data_enabled'
          },
          enableFusionMaritimeTargetData: {
            permissionRef: 'map_widget_fusion_maritime_target_data_enabled'
          }
        }
      },
      addComponent: {
        title: '#TRANSLATE-LATER#MAP.WIDGET.TITLE',
        componentName: 'MapWidgetAddComponent',
        component: MapWidgetAddComponent,
      },
      viewComponent: {
        title: 'MAP',
        componentName: 'MapWidgetViewComponent',
        component: MapWidgetViewComponent,
      },
      settingComponent: {
        componentName: 'MapWidgetSettingsComponent',
        component: MapWidgetSettingsComponent,
        dialogConfig: {
          width: this.pluginInjectorService.getMenuDialogConfig().width
        }
      }
    }]
  };

  constructor(private readonly pluginInjectorService: PluginInjectorService) {
    this.plugin.name = 'MAP';
    this.plugin.enabled = false;
    this.plugin.description = 'Map Plugin';
    this.plugin.permissions = {
      widget_permissions: this.widgetPermissions
    }
    this.plugin.modules = [this.pluginModule];
    this.plugin.version = '0.0.1';
  }

  setup(): void {
    this.initPlugin();
  }

  private initPlugin(): void {
    this.pluginInjectorService.register(this.plugin);
  }
}
